import { Injectable } from '@angular/core';
import { AngularFireDatabase  } from 'angularfire2/database/database';
//import { DateTime } from 'ionic-angular';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AuthProvider } from '../providers/auth/auth';
import { Alert } from '../../node_modules/ionic-angular/umd';
import { THIS_EXPR } from '../../node_modules/@angular/compiler/src/output/output_ast';


@Injectable()
export class PartesService{
  constructor(public afDB: AngularFireDatabase,public auth : AuthProvider,){
    //this.usuario =  this.getUsuario();
    this.usuario = 0;
    this.getPersonal()
    .subscribe(personal => {
      this.personal = personal;
    });

    this.getPartesOrdenado()
    .subscribe(partes => {
      this.partes = partes;
    });        
       
  }

  //Variables
  usuario : number;
  //cuadrillas = [];
  personal = [];
  partes = [];
  NombreUsuario : '';
  // Añadir y eliminar CUADRILLAS
  public addCuadrilla(cuadrilla){
    this.afDB.database.ref('/cuadrillas/' + cuadrilla.id).set(cuadrilla);
  } 

  public deleteCuadrilla(cuadrilla){
    this.afDB.database.ref('/cuadrillas/' + cuadrilla.id).remove();
  }
  //Devuelve el nombre de Usuari actual
  public getNombreUsuario(){
    return this.NombreUsuario;
  }

  //Añadir,editar y eliminar PARTES    
  public editParte(parte){
    this.afDB.database.ref('/cuadrillas/' + this.usuario + '/partes/' + parte.id).set(parte);
  } 

  public deleteParte(parte){
    this.afDB.database.ref('/cuadrillas/' + this.usuario + '/partes/' + parte.id).remove();
  }
   
  // Añadir y eliminar PERSONAL
  public addPersona(persona){
    this.afDB.database.ref('/cuadrillas/' + this.usuario + '/personal/' + persona.id).set(persona);
  } 

  public deletePersona(persona){
    this.afDB.database.ref('/cuadrillas/' + this.usuario + '/personal/' + persona.id).remove();
  }
  
  // Añadir y eliminar VARIEDAD
  public addVariedad(variedad){
    this.afDB.database.ref('/variedades/' + variedad.id).set(variedad);
  } 

  public deleteVariedad(variedad){
    this.afDB.database.ref('/variedades/' + variedad.id).remove();
  }

  //Metodos set...
  public setUsuario(item){
    this.usuario = item.id;
   
    this.getPersonal()
    .subscribe(personal => {
      this.personal = personal;
    });

    this.getPartesOrdenado()
    .subscribe(partes => {
      this.partes = partes;
        }); 
    this.NombreUsuario = item.Nombre; 
  }

  //Metodos get...
  public getCuadrillas(){
    return this.afDB.list('/cuadrillas/');
  }
  public getPartesOrdenadoCuadrilla(cuadrilla){
    return this.afDB.list('/cuadrillas/' + cuadrilla.id + '/partes/',{query:{orderByChild: 'Orden'}});
  }
  public getPartesOrdenado(){
    return this.afDB.list('/cuadrillas/' + this.usuario + '/partes/',{query:{orderByChild: 'Orden'}});
  }
  public getPartes(){
    return this.afDB.list('/cuadrillas/' + this.usuario + '/partes/');
  }
  public getPersonal(){
    return this.afDB.list('/cuadrillas/' + this.usuario + '/personal/');
  }
  public getVariedades(){
    return this.afDB.list('/variedades/',{query:{orderByChild: 'Nombre'}});
  }  

  public getUsuario(){
    let strUsuario : string;
    let usuario : number;
    strUsuario = this.auth.getUser();
    strUsuario = strUsuario.substring(0,3);
    usuario = parseInt(strUsuario);
    return usuario;
  }

  //Devuelve el idParte siguiente.
  getIdParte(){
    let partesArray = [];
    
    this.getPartes()
    .subscribe(partes => {
      partesArray = partes;
    });

    if (partesArray.length <= 0){
      return 19000000 + this.usuario * 1000;
    }
    else{
      return partesArray[partesArray.length - 1].id;
    }
  }

}


// WEBPACK FOOTER //
// ./src/services/partes.services.ts